import getShorterText from "Common/componentUtils/getShorterText";
import { documentObjectIconMap } from "Common/dictionaries/documentObjectIconId";
import { themeVariables } from "Components/theme";
import classNames from "classnames";
import React, { useMemo } from "react";
const mainDataContainerStyle = {
    display: "grid",
    alignContent: "center",
    overflow: "hidden"
};
const imgStyle = {
    objectFit: "cover",
    display: "block",
    border: "0"
};
const documentObjectIdStyle = {
    fontSize: themeVariables["font-size-small"],
    color: themeVariables["gray-500"],
    overflow: "hidden",
    textOverflow: "ellipsis",
    paddingBottom: 2
};
export default function NodeLabel(props) {
    var _a;
    const labelRootStyle = useMemo(() => ({
        ...(props.style || {}),
        display: "grid",
        gridTemplateColumns: props.imgSize ? "auto 1fr" : "1fr",
        gap: 10,
        gridTemplateRows: "1fr",
        boxSizing: "border-box",
        alignItems: "center"
    }), [props.style, Boolean(props.imgSize)]);
    const displayNameStyle = useMemo(() => ({
        padding: "2px 0",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: props.whiteSpace,
        wordBreak: "break-word",
        lineHeight: themeVariables["line-height-medium"]
    }), [props.whiteSpace]);
    const imgSrc = useMemo(() => { var _a; return (((_a = props.data) === null || _a === void 0 ? void 0 : _a.Icon) ? documentObjectIconMap[props.data.Icon] : undefined); }, [(_a = props.data) === null || _a === void 0 ? void 0 : _a.Icon]);
    const imageContainerStyle = useMemo(() => props.imgSize
        ? {
            width: props.imgSize,
            height: props.imgSize,
            minHeight: props.imgSize,
            minWidth: props.imgSize
        }
        : undefined, [props.imgSize, imgSrc]);
    if (!props.data)
        return null;
    return (React.createElement("div", { className: classNames("node-label", props.data.Color && "node-label-colored", props.className), style: labelRootStyle, ...(props.attrs || {}) },
        Boolean(props.imgSize) && (React.createElement("div", { style: imageContainerStyle }, imgSrc && (React.createElement("img", { src: imgSrc, width: props.imgSize, height: props.imgSize, title: "", alt: "", style: imgStyle })))),
        React.createElement("div", { style: mainDataContainerStyle },
            props.data.Name && (React.createElement("div", { style: displayNameStyle, title: props.needHoverTitle ? props.data.Name : undefined }, getShorterText(props.data.Name, props.titleMaxLength))),
            React.createElement("div", { style: documentObjectIdStyle }, props.data.Id))));
}
NodeLabel.defaultProps = {
    imgSize: 40,
    titleMaxLength: 90,
    whiteSpace: "pre-wrap"
};
